module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "floorList"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.floorArr,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "align": "center",
      "width": "60",
      "label": "序号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                 " + _vm._s(scope.$index + (_vm.params.no - 1) * _vm.params.size + 1) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "controlFloor",
      "align": "center",
      "label": "空置楼层"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vacantArea",
      "align": "center",
      "width": "150",
      "label": "空置面积(平方米)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "decoration",
      "width": "150",
      "align": "center",
      "label": "装修情况"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "decorationInstructions",
      "width": "180",
      "align": "center",
      "label": "装修说明"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actualUtilization",
      "width": "180",
      "align": "center",
      "label": "实际利用率(%)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "floorHeight",
      "width": "120",
      "align": "center",
      "label": "层高(米)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "turnTowards",
      "width": "120",
      "align": "center",
      "label": "朝向"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "paymentMethod",
      "width": "120",
      "align": "center",
      "label": "交付方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "label": "报价(元/天/平方米)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n               " + _vm._s(_vm._f("priceTrans")(scope.row, 1)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "propertyCosts",
      "width": "180",
      "align": "center",
      "label": "物业费用(元/天/平方米)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "align": "center",
      "label": "是否出售"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(_vm._f("strTrans")(scope.row.isSell)) + "\n           ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "align": "center",
      "label": "出售说明"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n               " + _vm._s(_vm._f("priceTrans")(scope.row, 3)) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "width": "180",
      "align": "center",
      "label": "最高"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n               " + _vm._s(_vm._f("priceTrans")(scope.row, 2)) + "\n            ")]
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-38602677"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingInfos/components/recordFloor.vue
// module id = 1451
// module chunks = 1